export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00230.04db6b66.png";